import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../../axios";
import { Helmet } from "react-helmet";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./Create.module.css";

import FormikControl from "../../../components/FormikControl/FormikControl";
import Button from "../../../components/Button/Button";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";

class Create extends Component {
  state = {
    isLoading: false,
    password: "",
    formId: 1,
  };

  setPassword = (password) => {
    this.setState({ password: password });
  };

  render() {
    const initialValues = {
      user_id: "",
      invoice: "",
    };

    const validationSchema = Yup.object({
      user_id: Yup.string().required("User is required"),
      invoice: Yup.mixed().required("Invoice is required"),
    });

    const onSubmit = (values) => {
      this.setState({ isLoading: true });

      const formData = new FormData();
      formData.append("user_id", values.user_id);
      formData.append("invoice", values.invoice);

      axios
        .post("/invoices", formData)
        .then((response) => {
          toast.success(response.data.message);
          this.setState((prevState) => ({
            formId: prevState.formId + 1,
          }));
        })
        .catch((error) => {
          if (error.response.data.code === 2001) {
            const errors = error.response.data.errors;
            toast.error(Object.values(errors[0])[0]);
          } else {
            toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    };

    // load Users
    const loadUsers = (inputValue) => {
      return axios
        .get(`/users?page=1&per-page=999&keyword=${inputValue}`)
        .then((res) => res.data);
    };

    return (
      <div className={styles.Create}>
        <Helmet>
          <title>New | Invoices | Lara Capital</title>
        </Helmet>
        <div className="PageHeader">
          <div className="ContentLeft">
            <div className="Title">
              <h1>Invoices</h1>
            </div>
            <Breadcrumb>
              <li>
                <Link to="/">Dashboard</Link>
              </li>
              <li>
                <Link to="/Invoices">Invoices</Link>
              </li>
              <li>New</li>
            </Breadcrumb>
          </div>
        </div>
        <div className="PageContent DataForm">
          <div className="ContentHeader">
            <div className="Title">
              <h1>Create Invoice</h1>
            </div>
          </div>
          <div className="MainContent">
            <div className="FormContainer">
              <Formik
                key={this.state.formId}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ setFieldValue }) => {
                  return (
                    <Form>
                      <div className={["FormBody", styles.FormBody].join(" ")}>
                        <FormikControl
                          control="selectAsync"
                          label="User"
                          name="user_id"
                          value=""
                          setFieldValue={setFieldValue}
                          loadOptions={loadUsers}
                        />

                        <FormikControl
                          control="fileInput"
                          label="Invoice *"
                          name="invoice"
                          accept=".pdf"
                          setFieldValue={setFieldValue}
                          fileFormats="PDF"
                          maxFileSize="10MB"
                          value=""
                        />
                      </div>

                      <div
                        className={["FormActions", styles.FormActions].join(
                          " "
                        )}
                      >
                        <Button
                          btnType="Primary"
                          type="Submit"
                          width="W100"
                          isLoading={this.state.isLoading}
                        >
                          Save
                        </Button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default Create;
